import { useEffect } from "react";
import ListUserPaged from "../components/ListUserPaged";
import PageSelector from "../components/PageSelector";
import usePagedUser from "../hooks/usePagedUser";
import useOrdinationStore from "../store/ordinationStore";
import "./Users.css";
import { useState } from "react";

const Users = () => {
  const page = useOrdinationStore((state) => state.page);
  const pageSize = useOrdinationStore((state) => state.pageSize);
  const name = useOrdinationStore((state) => state.name);
  const fieldOrder = useOrdinationStore((state) => state.fieldOrder);
  const currentOrder = useOrdinationStore((state) => state.currentOrder);
  const resetOrdination = useOrdinationStore((state) => state.resetOrdination);

  useEffect(() => {
    resetOrdination();
  }, [resetOrdination])

  const [searchTerm, setSearchTerm] = useState(name);

  const { data, isLoading, error } = usePagedUser({
    pageSize,
    page,
    name: searchTerm,
    fieldOrder,
    currentOrder,
  });

  if (isLoading) return <div>Loading...</div>;
  if (error) return <div>Error loading users</div>;

  const handleClearSearch = () => {
    setSearchTerm("");
    useOrdinationStore.getState().setName("");
  };

  return (
    <div className="user-page-container">
      <div className="user-list-header">
        <h2>Trainers</h2>
        <div className="search-input-container">
          <input
            type="text"
            placeholder="Search by name..."
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              useOrdinationStore.getState().setName(e.target.value);
            }}
          />
          {searchTerm && (
            <button className="clear-search-button" onClick={handleClearSearch}>
              X
            </button>
          )}
        </div>
      </div>
      <ListUserPaged users={data!} currentPage={page} pageSize={pageSize} />
      <PageSelector {...data!} />
    </div>
  );
};

export default Users;
